export const GetProductById = (api, productId, productFilters) => {
    return api.post(`api/v1/Product/GetProductByIndex?index=${productId}`, productFilters)
}

let cancelToken;
export const GetSearchingResult = async (api, productFilter, cancelToken) => {
    //return await api.get(`/api/v1/Product/Searching?searchingString=${searchingString}&custId=${custId}&siteId=${siteId}&whId=${whId}&allArticle=${tmpAllArticle}`, { cancelToken: cancelToken.token });    
    return await api.post(`/api/v1/Product/Searching`, productFilter, { cancelToken: cancelToken })
}

export const GetCategory = (api, productFilters) => {
    return api.post(`/api/v1/Product/GetCategory`, productFilters)
}

export const AddProductToFavorite = (api, artNo) => {
    return api.post(`/api/v1/Product/addProductToFavorite?artNo=${artNo}`, null)
}

export const AddProductToLastWatched = (api, artNo) => {
    return api.post(`/api/v1/Product/addProductToLastWatched?&artNo=${artNo}`, null)
}

export const RemoveProductFromFavorite = (api, artNo) => {
    return api.delete(`/api/v1/Product/removeProductFromFavorite?artNo=${artNo}`)
}

export const GetFavoriteProducts = (api, custId, siteId, whId) => {
    return api.get(`/api/v1/Product/getAllFavouriteProducts?custId=${custId}&siteId=${siteId}&whId=${whId}`)
}

export const GetLastWatchedProducts = (api, custId, siteId, whId) => {
    return api.get(`/api/v1/Product/getLastWatchedProducts?custId=${custId}&siteId=${siteId}&whId=${whId}`)
}

export const GetSimilarProductsByMainArtNo = (api, product, custId, siteId, whId) => {
    return api.get(`/api/v1/Product/GetSimilarProductsByMainArtNo?mainArtNo=${product.mainArtNo ? product.mainArtNo : 'undefined'}&artNo=${product.index}&custId=${custId}&siteId=${siteId}&whId=${whId}`)
}

export const GetProductsBySerialByArtNo = (api, artNo, custId, siteId, whId) => {
    return api.get(`/api/v1/Product/GetProductsBySerialByArtNo?artNo=${artNo}&custId=${custId}&siteId=${siteId}&whId=${whId}`)
}

export const GetRelatedProducts = (api, artNo, custId, siteId, whId) => {
    return api.get(`/api/v1/Product/GetRelatedProducts?artNo=${artNo}&custId=${custId}&siteId=${siteId}&whId=${whId}`)
}

export const GetRelatedProductsForArtsList = (api, artsNoList, custId, siteId, whId) => {
    return api.post(
        `/api/v1/Product/GetRelatedProductsForArtsList?custId=${custId}&siteId=${siteId}&whId=${whId}`,
        artsNoList
    )
}

export const GetAvailabilityFiltersNames = (api, cancelToken) => {
    return api.get(`/api/v1/Product/GetAvailabilityFiltersNames`, { cancelToken: cancelToken })
}

export const GetSuppliers = (api, productFilters, cancelToken) => {
    return api.post('/api/v1/Product/getSuppliers', productFilters, { cancelToken: cancelToken })
}

export const CheckMinimumPrice = (api, custId, artNo, priceNet) => {
    return api.get(`/api/v1/Product/CheckMinimumPrice?custId=${custId}&artNo=${artNo}&priceNet=${priceNet}`)
}

export const GetProductsFeaturesWithQuery = (api, productFilters, cancelToken) => {
    return api.post('/api/v1/Product/GetProductsFeatures', productFilters, { cancelToken: cancelToken })
}

export const GetLastPriceListGenerateDateForCustomer = (api, custId) => {
    return api.get(`/api/v1/Product/getLastPriceListGenerateDateForCustomer?custId=${custId}`)
}

export const GetProductsCountForNoCategoryActive = (api, productFilters) => {
    return api.post('/api/v1/Product/getProductsCountForNoCategoryActive', productFilters)
}

export const GetProductsAvailabilityLevel = (api, artsNo, whId, siteId) => {
    return api.post(`/api/v1/Product/GetProductsAvailabilityLevel?whId=${whId}&siteId=${siteId}`, artsNo)
}

